export default __webpack_public_path__ + "static/media/Foto galerija 1.1cb15aeb.jpg";